import { ref } from 'vue'

export function usePagination({ props }) {
  // 分页
  const page = ref({
    pageNo: 1,
    pageSize: props.pageSize,
  })

  // 分页-每页显示n条变化时出发
  const changePaginationSize = (val) => {
    page.value.pageSize = val
  }

  // 分页-页码变化时触发
  const changePaginationCurrent = (val) => {
    page.value.pageNo = val // 保存页码数据
  }

  return { page, changePaginationSize, changePaginationCurrent }
}
